export interface Config {
  /** The URL the app is hosted at */
  baseUrl: string;

  /** Internationalization configuration */
  i18n: {
    /** The languages supported by the app */
    languages: string[];
  };

  /** Data related configuration */
  data: {
    upload: {
      /** The maximum file size in bytes */
      maxFileSize: number;

      /** A list of allowed mime types */
      allowedMimeTypes: string[];

      /** A list of allowed file name extensions provided to the input element */
      allowedFilenameExtensions: string[];
    };

    /** Thresholds used to indicate a low confidence */
    confidenceTreshold: {
      separability: number;
      orientabilityL1: number;
      orientabilityL2: number;
      orientabilityL3: number;
      irNecessity: number;
      tangibility: number;
    };
  };

  /** Configuration related to the neural network backend */
  network: {
    /** The API key */
    apiKey: string;

    /** The url of the neural network backend */
    backendUrl: string;

    /** The url used to send the results to from the neural network */
    callbackUrl: string;

    /** The credentials used to retrieve the model data */
    credentials: string;
  };
}

export const configFn = (): Config => {
  const {
    REACT_APP_BASEURL,
    REACT_APP_CONFIDENCE_THRESHOLD_SEPARABILITY,
    REACT_APP_CONFIDENCE_THRESHOLD_ORIENTABILITYL1,
    REACT_APP_CONFIDENCE_THRESHOLD_ORIENTABILITYL2,
    REACT_APP_CONFIDENCE_THRESHOLD_ORIENTABILITYL3,
    REACT_APP_CONFIDENCE_THRESHOLD_IRNecessity,
    REACT_APP_CONFIDENCE_THRESHOLD_TANGIBILITY,
    REACT_APP_NETWORK_APIKEY,
    REACT_APP_NETWORK_BACKENDURL,
    REACT_APP_NETWORK_CALLBACKURL,
    REACT_APP_NETWORK_CREDENTIALS,
    REACT_APP_I18N_LANGUAGES,
  } = process.env;

  return {
    baseUrl: REACT_APP_BASEURL || '',
    i18n: {
      languages:
        REACT_APP_I18N_LANGUAGES && REACT_APP_I18N_LANGUAGES !== ''
          ? REACT_APP_I18N_LANGUAGES.split(',')
          : ['de', 'en'],
    },
    data: {
      upload: {
        // Don't forget to adjust the error messages too (i18n files)
        maxFileSize: 10485760,
        allowedFilenameExtensions: ['.step'],
        // Seems like the browser can't determine the type of a .STEP file
        allowedMimeTypes: [''],
      },
      confidenceTreshold: {
        separability: +(REACT_APP_CONFIDENCE_THRESHOLD_SEPARABILITY || 1),
        orientabilityL1: +(REACT_APP_CONFIDENCE_THRESHOLD_ORIENTABILITYL1 || 1),
        orientabilityL2: +(REACT_APP_CONFIDENCE_THRESHOLD_ORIENTABILITYL2 || 1),
        orientabilityL3: +(REACT_APP_CONFIDENCE_THRESHOLD_ORIENTABILITYL3 || 1),
        irNecessity: +(REACT_APP_CONFIDENCE_THRESHOLD_IRNecessity || 1),
        tangibility: +(REACT_APP_CONFIDENCE_THRESHOLD_TANGIBILITY || 1),
      },
    },
    network: {
      apiKey: REACT_APP_NETWORK_APIKEY || 'missing token',
      backendUrl: REACT_APP_NETWORK_BACKENDURL || 'http://localhost',
      callbackUrl: REACT_APP_NETWORK_CALLBACKURL || 'http://localhost',
      credentials: REACT_APP_NETWORK_CREDENTIALS || 'missing credentials',
    },
  };
};

export default configFn();
